<template>
    <svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M27.9643 0H1.03571C0.462835 0 0 0.467187 0 1.04545V21.9545C0 22.5328 0.462835 23 1.03571 23H27.9643C28.5372 23 29 22.5328 29 21.9545V1.04545C29 0.467187 28.5372 0 27.9643 0ZM26.6696 3.61989V20.6477H2.33036V3.61989L1.43705 2.91747L2.70904 1.26761L4.09431 2.35554H24.9089L26.2942 1.26761L27.5662 2.91747L26.6696 3.61989ZM24.9089 2.35227L14.5 10.5199L4.09107 2.35227L2.7058 1.26435L1.43382 2.9142L2.32712 3.61662L13.3834 12.2939C13.7013 12.5432 14.0925 12.6786 14.4951 12.6786C14.8978 12.6786 15.289 12.5432 15.6069 12.2939L26.6696 3.61989L27.5629 2.91747L26.291 1.26761L24.9089 2.35227Z"
            fill="black"
        />
    </svg>
</template>

<script>
//#e24444
export default {
    name: "MailIcon",
    props: {
        color: {
            type: String,
            default: "#29b6f6",
        },
    },
};
</script>

<style scoped></style>
